const imageMetadata = {
    "00375_20250406z.jpg": { title: "Her - Hanji Series (2025)", size: "46 x 53 cm" },
    "00374_20250406z.jpg": { title: "Her - Hanji Series (2025)", size: "46 x 53 cm" },
    "00373_20250406z.jpg": { title: "Her - Hanji Series (2025)", size: "46 x 53 cm" },
    "00372_20250406z.jpg": { title: "Her - Hanji Series (2025)", size: "46 x 53 cm" },
    "00371_20250406z.jpg": { title: "Her - Hanji Series (2025)", size: "46 x 53 cm" },
    "00370_20250406z.jpg": { title: "Her - Hanji Series (2025)", size: "91 x 117 cm" },
    "00369_20250406z.jpg": { title: "Her - Hanji Series (2025)", size: "38 x 46 cm" },
    "00368_20250406z.jpg": { title: "Her - Hanji Series (2024)", size: "20 x 20 cm" },
    "00367_20250406z.jpg": { title: "Her - Hanji Series (2024)", size: "20 x 20 cm" },
    "00366_20250406z.jpg": { title: "Her - Hanji Series (2024)", size: "20 x 20 cm" },
    "00365_20250406z.jpg": { title: "Her - Hanji Series (2024)", size: "20 x 20 cm" },
    "00364_20250406z.jpg": { title: "Her - Hanji Series (2024)", size: "20 x 20 cm" },
    "00363_20250406z.jpg": { title: "Her - Hanji Series (2025)", size: "73 x 91 cm" },

};

export default imageMetadata;
